module.exports = __webpack_public_path__ + "static/media/whytransp.eb373913.png";